import { schema } from 'normalizr';
import { commentSchema } from './commentSchema';

export const activitySchema = new schema.Entity('activity', {
  lastComment: commentSchema,
});
